import React from 'react'
import styled, { css } from 'styled-components'

import {
  marginSizes,
  padding,
  paddingSizes
} from '@jarvis.oddle/core/theme/default'
import Card from '@jarvis.oddle/core/components/Card'
import breakpoint from 'src/utils/styledComponentsBreakpoint'
import { H1, P } from '@jarvis.oddle/core/components/Typo'
import { createUrl } from 'src/utils/routes'
import { getColorString } from '@jarvis.oddle/core/tools/style'
import Flex from '@jarvis.oddle/core/components/Flex'

import LinkButton from './LinkButton'

const ImageTextContainer = styled(Card)`
  margin-bottom: 30px; /* WORKAROUND: To make box-shadow visible. */
  display: flex;
  flex-direction: column;
  padding-top: ${padding[paddingSizes.medium]};
  padding-bottom: ${padding[paddingSizes.extraLarge]};
  align-items: center;
  background-color: ${(props) =>
    props.backgroundColorMobile || props.theme.colorContainerColor};
  border-radius: 0;
  ${breakpoint('desktop')`
    position: absolute;
    top: 50%;
    ${(props) => (props.align === 'right' ? 'right: 120px;' : '')}
    ${(props) => (props.align === 'left' ? 'left: 120px;' : '')}
    ${(props) => (props.align === 'center' ? 'left: 50%;' : '')}
    width: 400px;
    transform: ${(props) =>
      props.active ? 'translateY(-50%)' : 'translateY(calc(-50% + 20px))'} ${(
    props
  ) => (props.align === 'center' ? 'translateX(-50%)' : '')};
    opacity: ${(props) => (props.active ? 1 : 0)};
    transition: all 0.3s ease-in-out;
    background-color: ${(props) =>
      props.backgroundColorDesktop
        ? getColorString(props.backgroundColorDesktop)
        : 'transparent'};
    padding-top: ${padding[paddingSizes.medium]};
    padding-bottom: ${padding[paddingSizes.medium]};
    margin-bottom: 0;
    box-shadow: none;
  `}
`
const textStyle = css<{
  colorMobile: string
}>`
  ${(props) => (props.colorMobile ? `color: ${props.colorMobile};` : '')}
  ${breakpoint('desktop')`
    ${(props) => (props.colorDesktop ? `color: ${props.colorDesktop};` : '')}
  `}
`
const StyledH1 = styled(H1).attrs(() => ({
  bold: true,
  normalised: true,
  textAlign: 'center'
}))`
  ${textStyle}
`
const StyledP = styled(P).attrs(() => ({
  textAlign: 'center',
  marginTop: marginSizes.small,
  marginBottom: marginSizes.none
}))`
  ${textStyle}
`

interface SlideOverlayProps {
  active: boolean
  previewMode: boolean

  // handle spreading props for unknown type
  [x: string]: unknown
}

const SlideOverlay = ({
  active,
  enableOverlay,
  textPosition,
  headingsText,
  subheadingsText,
  buttonLink,
  previewMode,
  buttonLabel,
  overlayColorDesktop,
  overlayColorMobile,
  textColorDesktop,
  textColorMobile,
  buttonLabel2,
  buttonLink2
}: SlideOverlayProps): JSX.Element => {
  return enableOverlay && (headingsText || subheadingsText || buttonLabel) ? (
    <ImageTextContainer
      active={active}
      align={textPosition}
      backgroundColorDesktop={overlayColorDesktop}
      backgroundColorMobile={overlayColorMobile}
    >
      {headingsText && (
        <StyledH1 colorDesktop={textColorDesktop} colorMobile={textColorMobile}>
          {headingsText}
        </StyledH1>
      )}
      {subheadingsText && (
        <StyledP colorDesktop={textColorDesktop} colorMobile={textColorMobile}>
          {subheadingsText}
        </StyledP>
      )}
      <Flex>
        {buttonLabel && (
          <LinkButton
            previewMode={previewMode}
            href={buttonLink && createUrl(buttonLink as string)}
          >
            {buttonLabel}
          </LinkButton>
        )}
        {buttonLabel2 && buttonLink2 && (
          <>
            <LinkButton
              previewMode={previewMode}
              href={createUrl(buttonLink2 as string)}
            >
              {buttonLabel2}
            </LinkButton>
          </>
        )}
      </Flex>
    </ImageTextContainer>
  ) : null
}

export default SlideOverlay
